import {
  UsersApi,
  CompaniesApi,
  CompaniesAdminApi,
  ReportsApi,
  FormsApi,
  RecommendationsApi,
  CurrenciesApi,
  NACEApi,
  AssignmentsConfigApi,
  QuestionsConfigApi,
  EuTaxonomyCompanyActivityApi,
  EuTaxonomyActivityApi,
  GlossaryApi,
  SubmissionsApi,
  ProcurementApi,
  RevenueAndExpensesApi,
  CsobHubApi,
  QuestionUnitsApi,
  AbstractFileStorageApi,
  FormsSectionsConfigApi,
  FormsConfigApi,
  FileStorageApi,
  FormAuditApi,
  SendMailApi,
  CustomModalsApi,
  ProcurementFileManagementApi,
  FoldersApi,
  FilesApi,
  OnlyOfficeApi,
  PaygapApi,
  DoubleMaterialityStakeholdersApi,
  DoubleMaterialityAssessmentsApi,
  DoubleMaterialityQuestionsApi,
  DoubleMaterialityQuestionAnswersApi,
  DoubleMaterialitySurveysApi,
  DoubleMaterialityResultsApi,
  PSASApi,
  ServiceMarketplaceApi,
  AIFileSearchApi,
  EmissionFactorsApi,
  QuestionsApi,
  ApplicationFeatureFunctionalityApi,
} from "@green0meter/api-client";
import axios from "axios";

export { gtm } from "./gtm";

export const usersApi = new UsersApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const companiesApi = new CompaniesApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const companiesAdminApi = new CompaniesAdminApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const formsApi = new FormsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const formAuditApi = new FormAuditApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const formsConfigApi = new FormsConfigApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const formsSectionsConfigApi = new FormsSectionsConfigApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const submissionsApi = new SubmissionsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const reportsApi = new ReportsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const recommendationsApi = new RecommendationsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const currenciesApi = new CurrenciesApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const naceApi = new NACEApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const questionsAssignmentApi = new AssignmentsConfigApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const questionsConfigApi = new QuestionsConfigApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const questionsUnitApi = new QuestionUnitsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const euTaxonomyCompanyActivityApi = new EuTaxonomyCompanyActivityApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const euTaxonomyActivityApi = new EuTaxonomyActivityApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const glossaryApi = new GlossaryApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const procurementApi = new ProcurementApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);
export const procurementFileManagementApi = new ProcurementFileManagementApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const revenueAndExpensesApi = new RevenueAndExpensesApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const csobHubApi = new CsobHubApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const fileStorageApi = new AbstractFileStorageApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const fileApi = new FileStorageApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const sendMailApi = new SendMailApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const customModalsApi = new CustomModalsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const foldersApi = new FoldersApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const filesApi = new FilesApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const onlyOfficeApi = new OnlyOfficeApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const paygapApi = new PaygapApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const doubleMaterialityStakeholdersApi = new DoubleMaterialityStakeholdersApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const doubleMaterialityAssessmentsApi = new DoubleMaterialityAssessmentsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const doubleMaterialityQuestionsApi = new DoubleMaterialityQuestionsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const doubleMaterialityQuestionAnswersApi =
  new DoubleMaterialityQuestionAnswersApi(
    undefined,
    import.meta.env.VITE_API_BASE_URL,
    axios,
  );

export const doubleMaterialitySurveysApi = new DoubleMaterialitySurveysApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const doubleMaterialityResultsApi = new DoubleMaterialityResultsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const psasApi = new PSASApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const servicesMarketplaceApi = new ServiceMarketplaceApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const aiFileSearchApi = new AIFileSearchApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const emissionFactorsApi = new EmissionFactorsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const questionsApi = new QuestionsApi(
  undefined,
  import.meta.env.VITE_API_BASE_URL,
  axios,
);

export const applicationFeatureFunctionalityApi =
  new ApplicationFeatureFunctionalityApi(
    undefined,
    import.meta.env.VITE_API_BASE_URL,
    axios,
  );
